<div class="expandable-card-header-wrapper" (click)="toggleCard()">
    <ng-content select="expandable-card-header"></ng-content>
    <arrow-icon></arrow-icon>
</div>
<div class="expandable-card-body-wrapper" *ngIf="expanded" [@slideAnimation]>
    <ng-content select="expandable-card-body"></ng-content>
</div>